import React from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import Image from 'assets/images/vendor-success.webp';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BUSINESS_ROUTE } from 'data/global';

import './SuccessScreen.styles.scss';
import './SuccessScreen.styles.responsive.scss';

type SuccessScreenProps = {
  className?: string;
};

const SuccessScreen: React.FC<SuccessScreenProps> = (props) => {
  const { className } = props;

  const classes = classNames('success-screen', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <ResolveImage src={Image} asIllustration alt="Success screen." />

      <h1>{t('requestSuccessfullySent')}</h1>

      <p>{t('theSaleAdvisorWillReviewYourSubmission')}</p>

      <Link
        replace
        to={BUSINESS_ROUTE}
        className="ncoded-button ncoded-button--outline"
      >
        {t('visitOurPublicMarketplaceUC')}
      </Link>
    </div>
  );
};

export default SuccessScreen;
